@let portalOrder = portalOrder$ | async; @let state = stateService.getState();

<stepper
  [step]="Steps.ProtectionPlans"
  [isChangeMode]="portalOrder?.isChange"
  [ancillaryUpsell]="ancillaryUpsell"
/>

<div class="ancillary-bundle d-flex">
  <div class="w-100">
    <h2 class="semi-bold pb-4">Protect your trip</h2>

    @if (portalOrder?.isChange) {
      @let firstItem = ancillariesItems[0];
      <upsell-info-badge
        [type]="firstItem?.type"
        [pricePerTraveler]="firstItem?.pricePerTraveler"
        [class.covered]="!firstItem?.pricePerTraveler"
        class="mb-4"
      />
    }

    <div class="ancillary-bundle-items">
      @for (item of ancillariesItems; track item.type) {
        <div class="cursor-pointer w-100 flex-1">
          <ancillary-bundle-item
            [discountSize]="discountSize"
            [isSelected]="selectedAncillary === item"
            (click)="onSelectAncillary(item)"
            [data]="item"
          />
        </div>
      }
    </div>

    @if (ancillaryStatuses.length) {
      @let isBanner = isBundleAvailable && !isBundleSelected;
      <div [class.filled]="isBanner">
        <div class="ancillary-bundle-statuses" [class.separated]="isSeparatedStatusesCards">
          @for (
            status of ancillaryStatuses;
            track trackByAncillaryStatus(status);
            let last = $last
          ) {
            <div [class.filled]="last && isBanner && isSeparatedStatusesCards">
              <div
                class="ancillary-bundle-statuses-item"
                [class.separated]="isSeparatedStatusesCards"
              >
                <ancillary-status (showAllBenefits)="onShowAllBenefits($event)" [data]="status" />
              </div>

              @if (!last && !isSeparatedStatusesCards) {
                <div class="ancillary-bundle-statuses-separator w-100"></div>
              }
            </div>
          }
        </div>
        @if (isBanner) {
          <ng-container *ngTemplateOutlet="banner" />
        }
      </div>
    }

    <div class="d-flex flex-column flex-md-row">
      <div class="flex-1">
        <div class="d-none d-md-flex mt-6">
          <ds-button
            (click)="back()"
            variant="secondary"
            leadingIcon="chevronLeft"
            data-id="back"
            label="Back"
          />

          <ds-button
            (click)="onContinueClick()"
            class="ml-auto"
            data-id="submit"
            trailingIcon="chevronRight"
            label="Continue"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="ancillary-bundle-summary">
    <ng-container *ngTemplateOutlet="summaryBlock" />

    <client-review
      [data]="{
        date: '2w ago',
        summary: 'Great peace of mind',
        review:
          'The Cancel for Any Reason protection saved my vacation when I had to change my flight last minute. Got my refund quickly and their support team helped rebook everything. Worth every penny for the flexibility!',
        from: 'Jocelyn Press',
        img: '/assets/images/client_a.webp',
        details: 'San Francisco – Paris',
      }"
    />
  </div>

  <div class="d-flex flex-column flex-md-row d-md-none">
    <div class="d-flex flex-column">
      <ds-button
        (click)="onContinueClick()"
        data-id="submit"
        trailingIcon="chevronRight"
        label="Continue"
      />

      <ds-button
        (click)="back()"
        variant="secondary"
        leadingIcon="chevronLeft"
        class="mt-4"
        data-id="back"
        label="Back"
      />
    </div>
  </div>
</div>

<ng-template #allBenefitsTemplate>
  @if (selectedAllBenefits) {
    <ancillary-all-benefits
      (continueWithoutBundle)="onModalContinueWithoutBundle()"
      (continueWithBundle)="onModalContinueWithBundle()"
      (close)="closeModal()"
      [isBundleSelectActions]="isBundleSelectActions"
      [discountSize]="discountSize"
      [data]="selectedAllBenefits"
    />
  }
</ng-template>

<ng-template #banner>
  <div class="ancillary-bundle-statuses-banner">
    <div class="d-flex flex-column g-2">
      <h3 class="bold">Upgrade to bundle & save {{ discountSize }}% instantly</h3>
      <div class="d-flex g-1 align-items-center">
        <img height="20" width="20" src="assets/icons/travelers_fav.svg" alt="travelers_fav" />
        <p class="semi-bold text-lightblue-600">Travelers' favorite</p>
      </div>
    </div>

    <ds-button
      (click)="selectBundle()"
      variant="secondary"
      data-id="bundle-for-full-coverage"
      label="Bundle for full coverage"
    />
  </div>
</ng-template>

<ng-template #askToSignInTemplate>
  <ask-to-sign-in-modal
    (hideModal)="hideAskToSignInModal()"
    (continueAsGuest)="continueAsGuestFromSignInPrompt()"
    (showSignInModal)="showSignInModal()"
  />
</ng-template>

<ng-template #summaryBlock>
  @if (portalOrder) {
    <price-summary
      [option]="portalOrder"
      [disruptionProtection]="disruptionProtection"
      [tipsAmount]="state.tipsAmount"
      [bundle]="bundle"
      [cancelForAnyReason]="cancelForAnyReason"
      [promocodeDiscountAmount]="state.promocodeDiscountAmount"
    />
  }
</ng-template>
